export var ASSIGNMENTS_API = {
    assignments: '/api/teachers/groups/:groupId/assignments',
    assignment: '/api/teachers/groups/:groupId/assignments/:assignmentId',
    cancelAssignment: '/api/teachers/groups/:groupId/assignments/:assignmentId/cancel',
    cancelStudentAssignment: '/api/teachers/groups/:groupId/assignments/:assignmentId/cancel_student/:studentId',
    assignmentStudentDetails: '/api/teachers/groups/:groupId/assignments/:assignmentId/details/:studentId',
    assingmentFormInfo: '/api/teachers/groups/:groupId/assignment-form',
    groupInfo: '/api/teachers/groups/:groupId/assignments/group_info',
    assignmentCards: '/api/teachers/assignments/cards',
};
export var ASSIGNMENTS_ROUTES = {
    base: '*/assignments',
    assignmentsList: '/',
    createAssignment: '/new',
    createAssignmentFromAnother: '/reassign/:assignmentId',
    createAssignmentFromAnotherForStudent: '/reassign/:assignmentId/student/:studentId',
    assignmentDetails: '/:assignmentId/details',
};
export var getBaseName = function (url) {
    return url.replace(new RegExp("(^." + ASSIGNMENTS_ROUTES.base + ")(.*)$", 'g'), '$1');
};
